module.exports = __webpack_public_path__ + "img/gh.2d172636.svg";